import React from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import UiAction from '../../components/UiAction';
import UI_ACTIONS from '../../data/UiActionConstants';
import { useNavigate } from "react-router-dom";

const Index = () => {
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
      value: (row) => {
        return `${row.id} ` + (row.is_rental ? "Rental": "" )
      }
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Amount',
      attr: 'amount',
    },
    {
      ...defaultHeaderConfig,
      label: 'Lease Rental Amount',
      attr: 'lease_rental',
    },
    {
      ...defaultHeaderConfig,
      label: 'Activation Amount',
      attr: 'activation_amount',
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_vak.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id) }>
              <FontAwesomeIcon icon={faEdit}/>
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_vak.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New VAK</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  const onNewClick = () => {
    navigate('/vak/new');
  }

  const onEditClick = (id) => {
    navigate(`/vak/${id}/edit`)
  }

  return <ListingPageComponent
    key={PAGES.VoltUpAllocationKitListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.VoltUpAllocationKitListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'VoltUp Allocation Kit'}]}
    listingMutation={getApi('glks')}
    recordsKey="glks"
    className="voltup-allocation-kit-listing-page"
    contentHeading="VAK List - Results"
    headers={headers}
    searchBy={['Name']}
    tableHea tableHeaderActionsComponent={tableHeaderActionsComponent()}
  />
};

export default Index;
